import React, { useEffect } from 'react';
import axios from '../axios';
import { useNavigate } from 'react-router-dom';

export const Logout = ({ setToken }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const logout = async () => {
            try {
                const refreshToken = localStorage.getItem('refresh_token');
                if (!refreshToken) {
                    throw new Error('No refresh token found');
                }

                // Make the logout request with the refresh token
                await axios.post('/logout/', {
                    refresh_token: refreshToken
                }, {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

                // Only clear local storage and state after the logout request completes
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('username'); // Clear the username from local storage
                setToken(null); // Clear the token state
                axios.defaults.headers.common['Authorization'] = null;
                navigate('/');
                window.location.reload();
            } catch (e) {
                console.log('logout not working', e);
            }
        };

        logout();
    }, [navigate, setToken]);

    return <div>Logging out...</div>;
};

export default Logout;
